const backdropHueRotate = {
    name: "backdrop-hue-rotate",
    path: "/backdrop-hue-rotate",
    title: "backdrop-hue-rotate",
    description: "Utilities for applying backdrop-hue-rotate filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-hue-rotate-<number>': 'hue-rotate(<number>deg)',
            '-backdrop-hue-rotate-<number>': 'hue-rotate(calc(<number>deg * -1))'
        },
    },
    exampleData: [
        {
            "title": "backdrop-hue-rotate-90, backdrop-hue-rotate-180",
            "description": "to rotate the hue of an element by degrees:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-hue-rotate-15",
                        "text": "backdrop-hue-rotate-15",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-hue-rotate-90",
                        "text": "backdrop-hue-rotate-90",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-hue-rotate-180",
                        "text": "backdrop-hue-rotate-180",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  -backdrop-hue-rotate-45",
                        "text": "-backdrop-hue-rotate-45",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-hue-rotate-15" src="/img/mountains.jpg" />
<img class="backdrop-hue-rotate-90" src="/img/mountains.jpg" />
<img class="backdrop-hue-rotate-180" src="/img/mountains.jpg" />
<img class="-backdrop-hue-rotate-45" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropHueRotate;